import { format, parse } from 'date-fns';

/**
 * Converts seconds to hh:mm:ss
 * @param seconds time duration
 * @returns Formatted video string
 */
export const formatDuration = (seconds: number): string => {
  // Return mm:ss if seconds < 3600 (1 hour)
  if (seconds < 3600) {
    return new Date(seconds * 1000).toISOString().slice(14, 19);
  } else {
    return new Date(seconds * 1000).toISOString().slice(11, 19);
  }
};

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const isWeekend = (date: Date): boolean => {
  const day = date.getDay();
  return day === 0 || day === 6; // Sunday or Saturday
};

export const addBusinessDays = (startDate: Date, days: number): Date => {
  const currentDate = new Date(startDate);
  let remainingDays = days;

  while (remainingDays > 0) {
    currentDate.setTime(currentDate.getTime() + MS_PER_DAY);
    if (!isWeekend(currentDate)) {
      remainingDays--;
    }
  }

  return currentDate;
};

export const subtractBusinessDays = (startDate: Date, days: number): Date => {
  const currentDate = new Date(startDate);
  let remainingDays = days;

  while (remainingDays > 0) {
    currentDate.setTime(currentDate.getTime() - MS_PER_DAY);
    if (!isWeekend(currentDate)) {
      remainingDays--;
    }
  }

  return currentDate;
};

/**
 * Attempts to cast to JS date. If that fails, assumes
 * date format is the unrecognised dd/mm/yyyy format.
 * If that fails, just return the string as-is. We tried.
 * @param date
 * @returns
 */
export const formatDate = (date: string, includeTime?: boolean): string => {
  const stringPattern = includeTime ? 'dd/MM/yyyy - hh:mm a' : 'dd/MM/yyyy';
  try {
    return format(new Date(date), stringPattern);
  } catch (e) {
    console.warn(e);
    try {
      return format(parse(date, stringPattern, new Date()), stringPattern);
    } catch (e) {
      return date;
    }
  }
};

// Helper function to format the date in 'YYYY-MM-DD' format
export function formatDateToYYYYMMDD(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export const removeTimeInfoFromDate = (date: string | Date): string => {
  const d = 'string' == typeof date ? date : date.toISOString();
  return d.replace(/T.*$/, '');
};

export const replaceTimeInfoWithUtcInDate = (date: string | Date): string => {
  return format(new Date(date), 'yyyy-MM-dd') + 'T00:00:00.000Z';
};

export const utcDateToLocalDate = (date: string | Date): Date => {
  const dt = new Date(date);
  return new Date(dt.getTime() + dt.getTimezoneOffset() * 60000);
};

// format the date into e.g March 18, 2021 format.
export const formatDate_monthName_day_fullYear = (date: string): string => format(new Date(date), 'MMMM d, yyyy');
